(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrWorkOrderDeleteController',TrWorkOrderDeleteController);

    TrWorkOrderDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrWorkOrder','$scope'];

    function TrWorkOrderDeleteController($uibModalInstance, entity, TrWorkOrder,$scope) {
        var vm = this;

        vm.trtrWorkOrder = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrWorkOrder.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();
